import DomainExistsModal from './DomainExistsModal'
export default DomainExistsModal
